import {Auction} from 'domain-models'
import {store} from "../../store"

export type AuctionFilter = {
  type?: string | null
  Make?: number | null
  Model?: number | null
  Fuel?: number | null
  Body?: number | null
  Vin?: string | null
  PostalCode?: string | null
  AcceptedOn?: {from: string, to: string} | null
  auctionIds?: Array<number | string>
}

interface FetchAuctions {
  type: 'FETCH_AUCTIONS',
  auctions: Array<Auction>,
  current_page: number,
  last_page: number,
  next_page_url: null | string,
  filter: AuctionFilter,
}

type FetchAuctionResponse = {
  data: Array<Auction>
  current_page: number
  current_page_url: string
  from: null | number
  to: null | number
  last_page: number
  last_page_url: string
  next_page_url: null | string
  path: string
  per_page: number
  prev_page_url: string
  total: number
}

export type SubjectType = 'Vehicle' | 'Tireset' | 'Leading' | 'Leasing'

export const fetchAuctions = async (filter: AuctionFilter, subjectType: SubjectType) => {
  await store.dispatch(setAuctionsLoading(true))
  filter.auctionIds = undefined
  const response = await window.axios.get<FetchAuctionResponse>('/auctions', {params: {...filter, subjectType}})
  if (!response) {
    await store.dispatch(setAuctionsLoading(false))
    return
  }
  await store.dispatch(fetchAuctionsAction(response.data, filter))
}

export const fetchAuctionsByIds = async (auctionIds: Array<number | string>, subjectType: SubjectType) => {
  await store.dispatch(setAuctionsLoading(true))
  const response = await window.axios.post<FetchAuctionResponse>('/getAuctions', {params: {auctionIds, subjectType}})
  if (!response) {
    return
  }
  await store.dispatch(fetchAuctionsAction(response.data, {auctionIds}))
}

export const fetchAuctionsAction: (auctionData: FetchAuctionResponse, filter: AuctionFilter) => FetchAuctions = (auctionData, filter) => ({
  type: 'FETCH_AUCTIONS',
  auctions: auctionData.data,
  current_page: auctionData.current_page,
  last_page: auctionData.last_page,
  next_page_url: auctionData.next_page_url,
  filter: filter,
  total: auctionData.total
})

export interface AppendAuctions {
  type: 'APPEND_AUCTIONS'
  auctions: Array<Auction>
  current_page: number,
  next_page_url: string | null,
}

export const appendAuctions = async (currentAuctions: Array<Auction>, next_page_url: string, filter: AuctionFilter, subjectType: SubjectType) => {
  await store.dispatch(setAuctionsLoading(true))
  const response = await window.axios.get<FetchAuctionResponse>(next_page_url, {params: {...filter, subjectType}})

  if (response && response.data) {
    await store.dispatch(appendAuctionsAction([...currentAuctions, ...response.data.data], response.data.current_page, response.data.next_page_url))
  }
}

export const appendAuctionsAction: (auctions: Array<Auction>, current_page: number, next_page_url: string | null) => AppendAuctions = (auctions, current_page, next_page_url) => ({
  type: 'APPEND_AUCTIONS',
  auctions,
  current_page,
  next_page_url
})

export interface SetAuctions {
  type: 'SET_AUCTIONS'
  auctions: Array<Auction>
}

export const setAuctions: (auctions: Array<Auction>) => SetAuctions = auctions => ({
  type: 'SET_AUCTIONS',
  auctions,
})

export const setAuctionFilter = async (currentFilter: AuctionFilter, filter: AuctionFilter, subjectType: SubjectType) => {
  currentFilter.AcceptedOn = null;
  await store.dispatch(dispatchSetAuctionFilter({...currentFilter, ...filter}))
  await fetchAuctions({...currentFilter, ...filter}, subjectType)
}

export interface dispatchSetAuctionFilter {
  type: 'SET_AUCTION_FILTER'
  filter: AuctionFilter
}

export const dispatchSetAuctionFilter: (filter: AuctionFilter) => dispatchSetAuctionFilter = filter => ({
  type: 'SET_AUCTION_FILTER',
  filter
})

export interface ShowAuction {
  type: 'AUCTION_DETAILS'
  auction: Auction
}

export const showAuction: (auction: Auction) => ShowAuction = auction => ({
  type: 'AUCTION_DETAILS',
  auction,
})

export interface HideAuction {
  type: 'AUCTION_DETAILS'
}

export const hideAuction: () => HideAuction = () => ({
  type: 'AUCTION_DETAILS',
  auction: null
})

export interface ShowNewlyArrived {
  type: 'SHOW_NEWLY_ARRIVED'
  auctions: Array<Auction>
}

export const showNewlyArrived: (auctions: Array<Auction>) => ShowNewlyArrived = (auctions) => ({
  type: 'SHOW_NEWLY_ARRIVED',
  auctions: auctions,
  current_page: 1,
  last_page: 1,
  next_page: null
})


interface SetAuctionsLoading {
  type: 'SET_LOADING',
  loading: boolean
}

export const setAuctionsLoading: (loading: boolean) => SetAuctionsLoading = (loading) => ({
  type: 'SET_LOADING',
  loading
})

export interface MarkAuctionCancelled {
  type: 'MARK_AUCTION_CANCELLED'
  auctionId: number
}

export const markAuctionCancelled: (auctionId: number) => MarkAuctionCancelled = (auctionId) => ({
  type: 'MARK_AUCTION_CANCELLED',
  auctionId
})
